export function creditsForPages(pageCount, pagesPerCredit) {
  if (!Number.isInteger(pageCount) || pageCount < 1) throw new RangeError("pageCount must be positive")
  if (!Number.isInteger(pagesPerCredit) || pagesPerCredit < 1) throw new RangeError("pagesPerCredit must be positive")

  return Math.ceil(pageCount / pagesPerCredit)
}

export function smallestPackCovering(packs, deficit) {
  if (!Number.isInteger(deficit) || deficit < 1) return null

  return packs
    .filter(pack => Number.isInteger(pack.credits) && pack.credits >= deficit)
    .sort((left, right) => left.credits - right.credits)[0] || null
}
